export const ErrorCodes = {
  NFO_ENTITY_NOT_FOUND: 'NFO_ENTITY_NOT_FOUND',
  NFO_YEAR_NO_RECORD: 'NFO_YEAR_NO_RECORD',
  CON_DELETE_HAS_REFS: 'CON_DELETE_HAS_REFS',
  AUTH_YEAR_ACCESS_DENIED: 'AUTH_YEAR_ACCESS_DENIED',
  // ... etc
} as const;
